export default __webpack_public_path__ + "static/media/7.bb8d7cd4.jpg";